import RacePage from "./RacePage"

export default RacePage